import React, {useEffect, useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import {config} from "../config/config";

const AlumnoList = ({ onEdit, onDelete,reloadTrigger }) => {
    const [alumnos, setAlumnos] = useState([]);

    const fetchAlumnos = () => {
        fetch(`${config.apiUrl}/alumnos/asignaciones`, {})
            .then((res) => res.json())
            .then(setAlumnos)
            .catch(console.error);
    };

    useEffect(() => {
        fetchAlumnos();
    }, [reloadTrigger]);

    return (
        <div className="container mt-5">
            <h2 className="mb-4">Alumnos Asignados</h2>
            <table className="table table-striped table-bordered table-dark">
                <thead className="table-dark">
                <tr>
                    <th>ID</th>
                    <th>Usuario</th>
                    <th>Grado</th>
                    <th>Ciclo</th>
                    <th>Acciones</th>
                </tr>
                </thead>
                <tbody>
                {alumnos.map((alumno) => (
                    <tr key={alumno.alumno_id}>
                        <td>{alumno.alumno_id}</td>
                        <td>{alumno.alumno_nombre}</td>
                        <td>{alumno.grado_nombre}</td>
                        <td>{alumno.ciclo}</td>
                        <td className="text-center">
                            <button
                                className="btn btn-warning btn-sm me-2"
                                onClick={() => {

                                        onEdit(alumno);
                                    }
                                }
                            >
                                <FontAwesomeIcon icon={faEdit} />
                            </button>
                            <button
                                className="btn btn-danger btn-sm"
                                onClick={() => onDelete(alumno.alumno_id)}
                            >
                                <FontAwesomeIcon icon={faTrashAlt} />
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default AlumnoList;